import { render, staticRenderFns } from "./problemsList.vue?vue&type=template&id=f83d6e26&scoped=true&"
import script from "./problemsList.vue?vue&type=script&lang=js&"
export * from "./problemsList.vue?vue&type=script&lang=js&"
import style0 from "./problemsList.vue?vue&type=style&index=0&id=f83d6e26&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83d6e26",
  null
  
)

export default component.exports